






















































































































































import { Component, Vue } from 'vue-property-decorator';
import {
  getCalendar,
  updateCalender,
} from '@/serve/medicalAppointment/institutionManage';
import moment from 'moment';

interface DateItem {
  startTime: string;
  week: string;
  isRest: boolean;
  day: number;
  isHoliday: boolean;
  holidayName: string;
  people: number;
}
interface CalendarQuery<T> {
  tenantId: T;
  year: string;
}

@Component({
  name: 'Arrange',
})
export default class Arrange extends Vue {
  private tenant: { id?: number; name?: string } = {};
  private monData: string[] = [];
  private num = 0;
  private nowYearMon = '';
  private mapData = new Map();
  private checkData = new Map();
  private week = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
  private yearData: string[] = [
    moment().format('YYYY'),
    moment().add(1, 'years').format('YYYY'),
  ];
  private weekColumn: { [key: string]: number } = {
    星期一: 1,
    星期二: 2,
    星期三: 3,
    星期四: 4,
    星期五: 5,
    星期六: 6,
    星期日: 7,
  };
  private today = '';
  private year = '';
  private dateData: { [key: string]: DateItem[] } = {};
  private batchActions: {
    type: '下周' | '下下周' | '本年';
    title: string;
    visible: boolean;
  }[] = [
    { type: '下周', title: '设置下周每天可约人数', visible: false },
    { type: '下下周', title: '设置下下周每天可约人数', visible: false },
    { type: '本年', title: '设置本年每天可约人数', visible: false },
  ];

  private fillDateMap() {
    Object.keys(this.dateData).forEach((key) => {
      this.dateData[key].forEach((ele, index) => {
        if (!this.mapData.get(ele.startTime)) {
          this.mapData.set(ele.startTime, key + '-' + index);
        }
      });
    });
  }

  private async initDeploy(data: CalendarQuery<number>, nowYearMon: string) {
    const res = await getCalendar(data);
    this.dateData = res.data || {};
    this.monData = Object.keys(this.dateData);
    this.fillDateMap();
    this.nowYearMon = nowYearMon;
  }

  public async getArrange(row: { id: number; name?: string }) {
    this.year = moment().format('YYYY');
    this.tenant = row;
    this.today = moment().format('YYYY-MM-DD');
    this.initDeploy(
      { tenantId: row.id, year: this.year },
      moment().format('YYYY年MM月')
    );
  }

  private changeYears(year: string) {
    if (this.checkData.size > 0) {
      this.saveData();
    }
    this.year = year;
    this.initDeploy(
      { tenantId: this.tenant.id as number, year },
      year + '年01月'
    );
  }

  private leftRightBtn(type: 'left' | 'right') {
    const maxLength = this.monData.length;
    let index = this.monData.indexOf(this.nowYearMon);
    if (type === 'left') {
      index !== 0 && index--;
    } else {
      index < maxLength - 1 && index++;
    }
    this.nowYearMon = this.monData[index];
  }

  private weekDeploy(nums: 7 | 14) {
    const data: DateItem[] = [];
    let days = nums;
    while (days-- > 0) {
      const day = moment().add(days, 'days').format('YYYY-MM-DD');
      const mapVal = this.mapData.get(day);
      if (!mapVal) {
        continue;
      }
      const [key, index] = mapVal.split('-');
      this.dateData[key][index].people = this.num;
      data.push(this.dateData[key][index]);
    }
    this.saveData(null, data);
  }

  private async YearDeploy() {
    this.year = moment().format('YYYY');
    await this.initDeploy(
      { tenantId: this.tenant.id as number, year: this.year },
      moment().format('YYYY年MM月')
    );
    const list: DateItem[] = [];
    Object.keys(this.dateData).forEach((ele) => {
      this.dateData[ele].forEach((item) => {
        item.people = this.num;
        list.push(item);
      });
    });
    this.saveData(null, list);
  }

  private changeNum(type: '下周' | '下下周' | '本年') {
    const isEve =
      moment().format('YYYY年') !== moment().add(7, 'days').format('YYYY年');
    if ((type === '下周' || type === '下下周') && isEve) {
      this.$message({
        message: '涉及跨年操作建议手动保存修改',
        type: 'warning',
      });
      return;
    }
    if (type === '下周') {
      this.weekDeploy(7);
    } else if (type === '下下周') {
      this.weekDeploy(14);
    } else {
      this.YearDeploy();
    }
    this.batchActions.forEach((item) => {
      item.visible = false;
    });
  }

  private setCheck(item: DateItem) {
    this.checkData.set(item.startTime, item);
  }

  private async saveData(_event?: any, list = [...this.checkData.values()]) {
    const res = await updateCalender({
      tenantId: this.tenant.id as number,
      rosterList: list,
    });
    if (res.success) {
      this.$message({
        type: 'success',
        message: res.msg,
      });
      this.checkData.clear();
    }
  }

  public back() {
    this.$emit('arrangeBack');
  }
}
